module.exports = __webpack_public_path__ + "img/icon294.ec400a99.png";